import { db } from '../firebase/config';
import { 
  collection, 
  doc, 
  addDoc, 
  getDocs, 
  deleteDoc, 
  updateDoc,
  query, 
  where, 
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';

export const projectsService = {
  // Create a new project
  createProject: async (userId, projectName) => {
    try {
      console.log('Creating project in Firestore:', { userId, projectName }); // Debug log
      
      const projectData = {
        name: projectName,
        userId: userId,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        messages: [],
        isActive: false
      };

      console.log('Project data to save:', projectData); // Debug log

      const docRef = await addDoc(collection(db, 'projects'), projectData);
      
      console.log('Project created with ID:', docRef.id); // Debug log
      
      return {
        success: true,
        projectId: docRef.id,
        project: {
          id: docRef.id,
          ...projectData,
          createdAt: new Date(),
          updatedAt: new Date()
        }
      };
    } catch (error) {
      console.error('Error creating project:', error);
      console.error('Error details:', error.code, error.message); // More detailed error
      return {
        success: false,
        error: `Failed to create project: ${error.message}`
      };
    }
  },

  // Get all projects for a user
  getUserProjects: async (userId) => {
    try {
      console.log('Fetching projects for user:', userId); // Debug log
      
      const q = query(
        collection(db, 'projects'), 
        where('userId', '==', userId),
        orderBy('updatedAt', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      const projects = [];
      
      querySnapshot.forEach((doc) => {
        projects.push({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt?.toDate(),
          updatedAt: doc.data().updatedAt?.toDate()
        });
      });
      
      console.log('Fetched projects:', projects); // Debug log
      
      return {
        success: true,
        projects: projects
      };
    } catch (error) {
      console.error('Error fetching projects:', error);
      return {
        success: false,
        error: error.message,
        projects: []
      };
    }
  },

  // Update project (rename, save messages, etc.)
  updateProject: async (projectId, updates) => {
    try {
      const projectRef = doc(db, 'projects', projectId);
      const updateData = {
        ...updates,
        updatedAt: serverTimestamp()
      };

      await updateDoc(projectRef, updateData);
      
      return {
        success: true
      };
    } catch (error) {
      console.error('Error updating project:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Delete a project
  deleteProject: async (projectId) => {
    try {
      await deleteDoc(doc(db, 'projects', projectId));
      
      return {
        success: true
      };
    } catch (error) {
      console.error('Error deleting project:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Save current chat messages to project
  saveProjectMessages: async (projectId, messages) => {
    try {
      const projectRef = doc(db, 'projects', projectId);
      await updateDoc(projectRef, {
        messages: messages,
        updatedAt: serverTimestamp()
      });
      
      return {
        success: true
      };
    } catch (error) {
      console.error('Error saving project messages:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
};